import { render, staticRenderFns } from "./accountAsset.vue?vue&type=template&id=3ee62950&scoped=true"
import script from "./accountAsset.vue?vue&type=script&lang=js"
export * from "./accountAsset.vue?vue&type=script&lang=js"
import style0 from "./accountAsset.vue?vue&type=style&index=0&id=3ee62950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee62950",
  null
  
)

export default component.exports